import "./blog.css"
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import blogone from "../../img/blog1.jpeg"
import blogtwo from "../../img/blog2.png"
import blogthree from "../../img/blog3.png"
import blogfour from "../../img/blog4.png"
import blogfive from "../../img/blogfive.avif"
import blogsix from "../../img/blogsix.avif"
import blogseven from "../../img/blogseven.avif"
import blogeight from "../../img/blogeight.avif"
import { Link } from "react-router-dom";

function Blog(){
  const gettop=()=>{
    window.scrollTo({
      top:0,
      behavior:"smooth"
    })
  }
    return(
        <>
        <div className="blog mt-5">
           <div className="continer">
    <h4>Medical Blog</h4>
    <h5>The latest articles and medical tips</h5>
</div>
<div className="content">
 <div className="row g-3">

  <div className="col-md-4 d-flex">
    <Card className="w-100 h-100 d-flex flex-column">
      <Card.Img variant="top" src={blogone} />
      <Card.Body className="d-flex flex-column">
        <Card.Title>The Importance of Health and Maintaining a Healthy Lifestyle</Card.Title>

        <div className="flex gap-2 mb-2">
          <span className="badge bg-secondary me-2">Health</span>
          <span className="badge bg-secondary">Medical Tips</span>
        </div>

        <Card.Text className="flex-grow-1">
          Good health is the foundation of a happy and productive life. It helps prevent
          diseases and improves both mental and physical well-being through healthy habits.
        </Card.Text>
<Link to="/oneblog" className="nav-link" onClick={gettop}> 
        <Button variant="danger">Read More</Button>

</Link>

      </Card.Body>
    </Card>
  </div>


  <div className="col-md-4 d-flex">
    <Card className="w-100 h-100 d-flex flex-column">
      <Card.Img variant="top" src={blogtwo} />
      <Card.Body className="d-flex flex-column">
        <Card.Title>Important Medical Tips to Prevent Diseases</Card.Title>

        <div className="flex gap-2 mb-2">
          <span className="badge bg-secondary me-2">Health</span>
          <span className="badge bg-secondary">Medical Advice</span>
        </div>

        <Card.Text className="flex-grow-1">
          Discover simple daily habits that can help protect you from illness and
          improve your lifestyle through balanced nutrition and regular exercise.
        </Card.Text>

<Link to="/twoblog" className="nav-link" onClick={gettop}> 
        <Button variant="danger">Read More</Button>

</Link>      </Card.Body>
    </Card>
  </div>


  <div className="col-md-4 d-flex">
    <Card className="w-100 h-100 d-flex flex-column ">
      <Card.Img variant="top" src={blogfive}  className="text-center"/>
      <Card.Body className="d-flex flex-column">
        <Card.Title>The Benefits of Regular Exercise</Card.Title>

        <div className="flex gap-2 mb-2 ">
          <span className="badge bg-secondary ms-2 me-2">Fitness</span>
          <span className="badge bg-secondary">Healthy Lifestyle</span>
        </div>

        <Card.Text className="flex-grow-1">
          Regular physical activity improves heart health, increases energy levels,
          and helps reduce stress while strengthening muscles and body fitness.
        </Card.Text>

<Link to="/threeblog" className="nav-link" onClick={gettop}> 
        <Button variant="danger">Read More</Button>

</Link>      </Card.Body>
    </Card>
  </div>


  <div className="col-md-4 d-flex">
    <Card className="w-100 h-100 d-flex flex-column">
      <Card.Img variant="top" src={blogsix} />
      <Card.Body className="d-flex flex-column">
        <Card.Title>Healthy Nutrition for a Better Life</Card.Title>

        <div className="flex gap-2 mb-2">
          <span className="badge bg-secondary me-2">Nutrition</span>
          <span className="badge bg-secondary">Health</span>
        </div>

        <Card.Text className="flex-grow-1">
          A balanced diet with fruits, vegetables, proteins, and whole grains
          provides essential nutrients that support the body and strengthen immunity.
        </Card.Text>

<Link to="/fourblog" className="nav-link" onClick={gettop}> 
        <Button variant="danger">Read More</Button>

</Link>      </Card.Body>
    </Card>
  </div>
  <div className="col-md-4 d-flex">
    <Card className="w-100 h-100 d-flex flex-column">
      <Card.Img variant="top" src={blogseven} />
      <Card.Body className="d-flex flex-column">
        <Card.Title>The Importance of Health and Maintaining a Healthy Lifestyle</Card.Title>

        <div className="flex gap-2 mb-2">
          <span className="badge bg-secondary me-2">Health</span>
          <span className="badge bg-secondary">Medical Tips</span>
        </div>

        <Card.Text className="flex-grow-1">
          Good health is the foundation of a happy and productive life. It helps prevent
          diseases and improves both mental and physical well-being through healthy habits.
        </Card.Text>

<Link to="/fiveblog" className="nav-link" onClick={gettop}> 
        <Button variant="danger">Read More</Button>

</Link>      </Card.Body>
    </Card>
  </div>
  <div className="col-md-4 d-flex">
    <Card className="w-100 h-100 d-flex flex-column">
      <Card.Img variant="top" src={blogeight} />
      <Card.Body className="d-flex flex-column">
        <Card.Title>The Importance of Health and Maintaining a Healthy Lifestyle</Card.Title>

        <div className="flex gap-2 mb-2">
          <span className="badge bg-secondary me-2">Health</span>
          <span className="badge bg-secondary">Medical Tips</span>
        </div>

        <Card.Text className="flex-grow-1">
          Good health is the foundation of a happy and productive life. It helps prevent
          diseases and improves both mental and physical well-being through healthy habits.
        </Card.Text>

<Link to="/sixblog" className="nav-link" onClick={gettop}> 
        <Button variant="danger">Read More</Button>

</Link>      </Card.Body>
    </Card>
  </div>

</div>
    
</div>
        </div>
        </>
    )
}
export default Blog